import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import classes from './index.module.scss';
export const VariantTypes = {
    UNAVAILABLE: 'unavailable',
    INFO: 'info',
    VALID: 'valid',
    EMPTY: 'empty',
    INCOMPLETE: 'incomplete',
    INVALID: 'invalid',
    PENDING: 'pending',
    BLUE: 'blue',
};
export const SizeTypes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
function getSize(size) {
    switch (size) {
        case SizeTypes.SMALL:
            return 'var(--goto-caption-small-02)';
        case SizeTypes.LARGE:
            return 'var(--goto-body-large)';
        case SizeTypes.MEDIUM:
        default:
            return 'var(--goto-body-small)';
    }
}
function getColor(variant) {
    switch (variant) {
        case VariantTypes.UNAVAILABLE:
            return {
                chipColor: 'var(--goto-neutral-03)',
                textColor: 'var(--goto-text-02)',
                dotColor: 'var(--goto-ui-03)',
            };
        case VariantTypes.INFO:
            return {
                chipColor: 'var(--goto-information-02)',
                textColor: 'var(--goto-interactive-01)',
                dotColor: 'var(--goto-interactive-01)',
            };
        case VariantTypes.VALID:
            return {
                chipColor: 'var(--goto-success-03)',
                textColor: 'var(--goto-text-success-01)',
                dotColor: 'var(--goto-text-success-01)',
            };
        case VariantTypes.EMPTY:
            return {
                chipColor: 'var(--goto-orange-03)',
                textColor: 'var(--goto-text-warning-02)',
                dotColor: 'var(--goto-inverse-02)',
            };
        case VariantTypes.INCOMPLETE:
            return {
                chipColor: 'var(--goto-orange-03)',
                textColor: 'var(--goto-text-warning-02)',
                dotColor: 'var(--goto-text-warning-02)',
            };
        case VariantTypes.INVALID:
            return {
                chipColor: 'var(--goto-danger-03)',
                textColor: 'var(--goto-text-error-01)',
                dotColor: 'var(--goto-text-error-01)',
            };
        case VariantTypes.PENDING:
            return {
                chipColor: 'var(--goto-warning-03)',
                textColor: 'var(--goto-text-warning-01)',
                dotColor: 'var(--goto-text-warning-01)',
            };
        case VariantTypes.BLUE:
            return {
                chipColor: 'var(--goto-blue-100)',
                textColor: 'var(--goto-blue-500)',
                dotColor: 'var(--goto-blue-500)',
            };
        default:
            return variant;
    }
}
const StatusChip = ({ children, withDots = true, size = SizeTypes.MEDIUM, variant = {
    chipColor: null,
    textColor: 'var(--goto-text-01)',
    dotColor: 'var(--goto-text-01)',
}, className, }) => {
    const { chipColor, textColor, dotColor } = getColor(variant);
    const statusTextStyle = {
        color: textColor ? textColor : dotColor ? dotColor : null,
        '--status-text-size': getSize(size),
    };
    return (_jsxs("div", Object.assign({ style: { background: chipColor !== null && chipColor !== void 0 ? chipColor : 'unset' }, className: classNames(classes.statusPanel, className) }, { children: [withDots && (_jsx("span", { className: classNames(classes.status, !chipColor && classes.statusPosition), style: {
                    background: dotColor ? dotColor : undefined,
                } }, void 0)), _jsx(Typography, Object.assign({ className: classNames(classes.statusText, withDots ? classes.statusTextSimple : classes.statusTextWrapped), style: statusTextStyle }, { children: children }), void 0)] }), void 0));
};
export default StatusChip;
//# sourceMappingURL=index.js.map